import React from 'react';
import GetLearnings from './src/assets/data/getLearnings.json';

import LearningCard from './src/components/learning-card/learning-card';
import VideoContainer from './src/components/video-container/video-container';
import './main.scss';
// import './assets/style/theme.scss';

const App = () => {
    // console.log(GetLearnings);
    return (
        <div className="app-container">
          <VideoContainer></VideoContainer>

          {GetLearnings.map((content, index) => {
              return (
                  <LearningCard {...content} key={index}/>
              )
          })}
        </div>
    )
}

export default App;
